import React from 'react';
import './CeoSection.css';
// import photo from '../../assets/team.webp';
import photo from '../../assets/team/Meeting-bro.webp';

const CEOSection = () => {
  return (
    <section className="ceo-section">
      <div className="ceo-container">
        {/* CEO Image */}
        <div className="ceo-image">
          <img src={photo} alt="CEO" />
        </div>

        {/* CEO Content */}
        <div className="ceo-content">
          <h2 className="ceo-title">Über die Geschäftsführung</h2>
          <p className="ceo-intro">
            Die Geschäftsführung vereint wirtschaftliches und technisches Fachwissen mit einer langjährigen Erfahrung in der Entwicklung digitaler Lösungen. Mit akademischen Abschlüssen in Betriebswirtschaft und Informatik sowie Berufserfahrung in renommierten Unternehmen liegt der Fokus auf der Umsetzung innovativer und kundenorientierter Projekte.
          </p>

          <ul className="ceo-bullets">
            <li>B.Sc. Betriebswirtschaftslehre (Universität zu Köln)</li>
            <li>B.Sc. Informatik (Universität Bonn)</li>
            <li>Berufserfahrung bei Deloitte & Telekom</li>
            <li>Über 6 Jahre Erfahrung in Webentwicklung </li>
            <li>Schwerpunkt auf Innovation & kundenorientierte Lösungen</li>
          </ul>
        </div>
      </div>
    </section>
  );
};

export default CEOSection;
